import PankowForm from './pankow-form';

export default (di) => {
	di.setType({
		type: PankowForm,
		name: 'PankowForm',
		parent: 'PageComponent',
	});
};
